/**
 * Errors, in the reader's language.
 *
 * Failures arrive as `ApiError` with a stable `code` and an English `message`
 * written for whoever is debugging. Rendering that message straight into a
 * toast would hand a Russian planner an English sentence at the exact moment
 * something had gone wrong — so the UI branches on `code` and every word a
 * person reads comes from the catalogue.
 */
import { ApiError } from '../types'
import type { Catalogue } from './index'

/**
 * @param fallback the message for an error carrying no code we recognise —
 *   usually the specific one for the action that failed ("Export failed"),
 *   which says more than a generic apology.
 */
export function messageForError(t: Catalogue, error: unknown, fallback?: string): string {
  if (error instanceof ApiError) {
    const known = t.errors[error.code as keyof typeof t.errors]
    if (typeof known === 'string') return known
  }
  if (error instanceof TypeError) {
    // fetch() rejects with TypeError when it cannot reach the host at all.
    return t.errors.offline
  }
  return fallback ?? t.errors.unknown
}
